
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentControllerService, ReceiptControllerService } from '../api/services';
import { PaymentResponseDto, ProcessPayDto } from '../api/models';
import { FormBuilder,  FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { QRCodeComponent } from 'angularx-qrcode';
import { AngularDeviceInformationService } from 'angular-device-information';
import * as bootstrap from 'bootstrap';


@Component({
    selector: 'app-payment',
    imports: [
    ReactiveFormsModule,
    QRCodeComponent
],
    templateUrl: './payment.component.html',
    styleUrl: './payment.component.css'
})
export class PaymentComponent implements OnInit {



  orderDetails?:PaymentResponseDto;
  paymentNetwork:string ='';
  reference?:string;
  paymentNetworkOtpion:string='';
  isWallet:boolean =false;
  isPayment:boolean=true;
  qrCode:string='';
  errorMessage ='';
  isError=false;

  formPay:FormGroup;
  constructor(
    private formBuilder:FormBuilder,
    private activeRoute:ActivatedRoute,
    private route:Router,
    private paymentService:PaymentControllerService,
   private receiptService:ReceiptControllerService,
   private deviceInfo :AngularDeviceInformationService
  ){
   this.formPay = this.formBuilder.group({
    phone:['', [Validators.required]],
    otp:['']
   });
  }
  ngOnInit(): void {
    this.activeRoute.params.subscribe(p =>{
      this.reference =p['reference'];
      this.loadPaymentDetails();
      }); 
  }
  onSelectPaymentMethod(paymentNetwork:string){

    this;this.formPay.reset();
    this.paymentNetworkOtpion='';
    this.paymentNetwork = paymentNetwork;
    const methods = document.querySelectorAll('.payment-method');

    if(this.paymentNetwork == 'card'){
      this.isWallet = false;
   
    }else {
      this.isWallet =true;

    }

    methods.forEach(element => {
      
      if(element.getAttribute('data-method') == paymentNetwork){
        element.classList.add('active');

      }else {
        element.classList.remove('active');
      }
      
    });

  }
  onSelectPaymentOption(opt:string){
    this.paymentNetworkOtpion =opt;
    const methods = document.querySelectorAll('.payment-option');
    methods.forEach(element => {
      
      if(element.getAttribute('data-method') == opt){
        element.classList.add('active');

      }else {
        element.classList.remove('active');
      }
      
    });
    console.log(opt);
  }
  isValid():boolean{
     let valid =false;
    if(this.paymentNetwork =='card'){
      valid = true;
    }else {
      let phone = this.formPay.value.phone;
      if(this.paymentNetwork.toUpperCase() =='OMSN'){
        if(this.deviceInfo.isDesktop()){
          this.paymentNetworkOtpion ='qrcode';
        }else {
          this.paymentNetworkOtpion='maxit';
        }

      }
      valid = phone!=null&&phone.length>=9;

    }
    return valid;
  }


  loadPaymentDetails(){
    this.receiptService.getPaymentDetails(
      this.reference!!
    ).subscribe({
      next:(resp)=>{
        
        if(resp?.status == 'PENDING'){
          this.orderDetails = resp;
        }else{
          this.redirectFinalUrl(resp);
          
        }
      },
      error:(err)=> {
          console.log(err.error);
          this.errorMessage =err.error.message;
          this.isError =true;
          const elt =document.getElementById('modErrPay');
                     const modAdd = new bootstrap.Modal(elt!!);
                     modAdd.show();
      },
    });
  }
  processPayment(){
    console.log(this.reference);
    console.log(this.paymentNetwork);
    let phone = this.formPay.value.phone;
    console.log(this.deviceInfo.getDeviceType());
    
    let dto :ProcessPayDto = {
      reference:this.reference?this.reference:'',
      paymentNetwork:this.paymentNetwork,
      paymentMean: phone,
      payNetworkOption: this.paymentNetworkOtpion
    };
    this.paymentService.processPayment(
       dto
    ).subscribe({
      next:(resp)=>{
        if(resp.status =='PENDING'){
          if(this.paymentNetwork.toUpperCase() == 'OMSN'){
            this.handleOrangemoneyResponse(resp);
          }else{
            if(resp.paymentUrl){
              this.openUrl(resp.paymentUrl);
            }
          }
        
      }
      }
    });

  }
  handleOrangemoneyResponse(resp:PaymentResponseDto){
    console.log('orange money');
    if(resp.status =='PENDING'){
      if(this.paymentNetworkOtpion=='maxit'){
        if(resp.paymentUrl){
        this.openUrl(resp.paymentUrl);
        }
      }else {
        this.qrCode =resp.qrCode!!;
        console.log(this.qrCode);
        this.isPayment =false;
        this.finalizePayment(resp.reference!!);
        
      }
    }

  }
  async finalizePayment(reference:string){
    
    this.receiptService.getPaymentDetails(
      reference
    ).subscribe({
      next:(resp)=>{
        console.log(resp);
        if(resp.status =='PENDING'){
          setTimeout(()=>
            {
              this.finalizePayment(reference);
            },
            60000);
        }else {
          this.redirectFinalUrl(resp);
          
        }
        
      },
      
    });
   
  }
  openUrl(url:string){

     window.open(url,'_self');
    //window.open(url,'_blank');
  }
  redirectFinalUrl(resp:PaymentResponseDto){
    if(resp.returnUrl ==null ||resp.returnUrl.length==0){
      this.route.navigateByUrl('receipt?reference='+resp.reference);
    }else {
      let data ='?reference='+resp.reference+'&requestId='+resp.requestId;
      data =data+'&status='+resp.status;
      this.openUrl(resp.returnUrl+data);

    }
  }
}
